<div mdbModal #seleccionarCliente="mdb-modal"  class="modal fade" id="basicExample" tabindex="-1" role="dialog"
aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" style="max-width: 1000px;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="mode === 'SEARCH'">
          Seleccionar cliente
        </h4>
        <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="mode === 'VIEW_SELECTED'">
          Seleccionados
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <form [formGroup]='formData' (ngSubmit)="buscar(true)" novalidate>
        <div class="modal-body" *ngIf="mode === 'SEARCH'">

          <!-- <div class="row">
            <div class="col">
              <strong>Buscar por: </strong>
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" [id]="idRadioBuscarPorNombre" formControlName="buscarPor"
                  [value]="TIPO_NOMBRE" (change)='cleanInput()' mdbInput />
                <label class="form-check-label" [for]="idRadioBuscarPorNombre">Nombre</label>
              </div>
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" [id]="idRadioBuscarPorRut" formControlName="buscarPor"
                  [value]="TIPO_RUT" (change)='cleanInput()' mdbInput />
                <label class="form-check-label" [for]="idRadioBuscarPorRut">Rut</label>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="nombreProduct" class="form-control" placeholder="Nombre del cliente"
                  #nombreProduct formControlName="nombre" />
                <label for="nombreProduct">Nombre del cliente</label>
                <!-- <div *ngIf="
                    formData.get('nombre').invalid &&
                    (formData.get('nombre').dirty ||
                    formData.get('nombre').touched)
                  ">
                  <mdb-error *ngIf="formData.get('nombre').hasError('required')">
                    Ingrese nombre
                  </mdb-error>
                </div> -->
              </div>
            </div>
            <div class="col" style="max-width: 150px;">
              <div class="md-form">
                <input value="" type="text" id="nombreProduct" class="form-control" placeholder="RUT del cliente"
                  #nombreProduct formControlName="rut" formatRut />
                <label for="nombreProduct">RUT del cliente</label>
                <!-- <div *ngIf="
                    formData.get('rut').invalid &&
                    (formData.get('rut').dirty ||
                    formData.get('rut').touched)
                  ">
                  <mdb-error *ngIf="formData.get('rut').hasError('required')">
                    Ingrese rut
                  </mdb-error>
                </div> -->
              </div>
            </div>
            <div class="col" style="width: 50px;">
              <button mdbBtn type="submit" class="btn-cuadrado" color="secondary" mdbWavesEffect>
                <mdb-icon fas icon="search"></mdb-icon>
              </button>
            </div>
          </div>

          <!-- <div class="row" *ngIf="busquedaIniciada && data.length === 0">
            <div class="col">
              <a mdbBtn color="info" class="waves-light" mdbWavesEffect>
                No existen registros para el filtro seleccionado</a>
            </div>
          </div> -->

          <table class="table table-striped table-hover table-sm align-middle" *ngIf="data && busquedaIniciada">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col" class="text-center">
                  <ng-container *ngIf="multiple && config.paginateLocally">
                    <mdb-checkbox (change)='checkAllChange($event)' [disabled]="!data || data.length === 0">
                      <span>
                        RUT
                      </span>
                    </mdb-checkbox>
                  </ng-container>
                  <ng-container *ngIf="!(multiple && config.paginateLocally)">
                    RUT
                  </ng-container>
                </th>
                <th scope="col" class="text-center">Nombre</th>
                <th scope="col" class="text-center" *ngIf="!onlyRut && !ocultarColumnaSucursal">Sucursal</th>
                <th *ngIf="!multiple">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="loading">
                <td colspan="100%" style="text-align: center">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
              </tr>
              <tr *ngIf="!loading && data?.length === 0">
                <td colspan="100%" style="text-align: center">
                  No se encontró información
                </td>
              </tr>
              <tr *ngFor="let cliente of data">
                <td *ngIf="multiple">
                  <mdb-checkbox [checked]="cliente.checked" (change)='checkCliente(cliente)' >
                    <span>
                      {{ cliente.rutFormato | rut }}
                    </span>
                  </mdb-checkbox>
                </td>
                <td *ngIf="!multiple">{{ cliente.rutFormato | rut }}</td>
                <td>
                  {{ cliente.razon_social }}
                  <small
                    *ngIf="cliente.sinDeudaCuentaCorriente && !permitirVisualizarClienteSinDeuda"
                    class="d-block text-warning font-weight-bold"
                  >
                    Sin deuda en cuenta corriente
                  </small>
                </td>
                <!-- <td *ngIf="queryType !== 'RUT_SUCURSAL'">{{ cliente.nombre }}</td> -->

                <td *ngIf="!onlyRut && !ocultarColumnaSucursal">{{ cliente.direccion_completa }}</td>
                <td *ngIf="!multiple">
                  <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                    (click)="selectData(cliente)">
                    Seleccionar
                  </button>
                </td>
              </tr>
            </tbody>
            <ng-container *ngIf="data.length > 0">
              <app-pagination *ngIf="!config.paginateLocally" [context]="paginationContext"
                (onPageChange)="onPageChange($event)"></app-pagination>
              <app-pagination *ngIf="config.paginateLocally" [context]="paginationContext"
                (onPageChange)="onPageChangeLocal($event)"></app-pagination>
            </ng-container>
          </table>
        </div>

        <div class="modal-body" *ngIf="mode === 'VIEW_SELECTED'">
          <h5 *ngIf="dataSeleccionadaAll?.length === 1">
            ({{dataSeleccionadaAll?.length | json}}) Seleccionado
          </h5>
          <h5 *ngIf="dataSeleccionadaAll?.length > 1">
            ({{dataSeleccionadaAll?.length | json}}) Seleccionados
          </h5>

          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">RUT</th>
                <th scope="col">Nombre</th>
                <th scope="col" class="text-center" *ngIf="!onlyRut && !ocultarColumnaSucursal">Sucursal</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cliente of dataSeleccionada">
                <td>{{ cliente.rutFormato | rut }}</td>
                <td>{{ cliente.razon_social }}</td>
                <!-- <td *ngIf="queryType !== 'RUT_SUCURSAL'">{{ cliente.nombre }}</td> -->
                <td *ngIf="!onlyRut && !ocultarColumnaSucursal">{{ cliente.direccion_completa }}</td>
                <td>
                  <ng-container *ngIf="config.allowUncheckSelected">
                    <button mdbBtn type="button" size="sm" color="danger" mdbWavesEffect class="btn-actions-sm"
                      (click)="checkCliente(cliente)">
                      <mdb-icon fas icon="trash"></mdb-icon>
                    </button>
                  </ng-container>
                  <!-- <mdb-checkbox [checked]="cliente.checked" (change)='checkCliente(cliente)' *ngIf="multiple">
                    <span>
                      {{ cliente.rutFormato | rut }}
                    </span>
                  </mdb-checkbox> -->
                </td>
              </tr>
            </tbody>
            <app-pagination [context]="paginationContext" (onPageChange)="onPageChangeLocalSelected($event)">
            </app-pagination>
          </table>
        </div>
      </form>
    </div>
  </div>
</div>
